export default {"src":"/_next/static/media/foodji.9d9953e2.svg","height":26,"width":73,"blurWidth":0,"blurHeight":0};